module.exports = "https://web-assets.ifttt.com/packs/media/icons/turned_on-5020f614.png";